import Icon from "@components/ui/icon";
import { useAppDispatch, useAppSelector } from "@store";
import { getAccount } from "@store/account/selectors";
import { closeDialog } from "@store/dialogs";
import { useValidateUpdateBillingDetails } from "../hooks/use-validate-update-billing-details";

const UpdateBillingDetailsDialog = ({ onClose }: { onClose?: () => void }) => {
  const account = useAppSelector(getAccount);
  const dispatch = useAppDispatch();
  useValidateUpdateBillingDetails();

  return (
    <div className="tw-relative tw-h-[95vh] tw-w-[95vw] tw-rounded-lg tw-bg-blue-100">
      <button
        type="button"
        onClick={() => {
          dispatch(closeDialog("update-billing-details"));
          onClose?.();
        }}
        className="tw-absolute tw-right-2 tw-top-2 tw-flex tw-size-10 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-shadow-main tw-transition-opacity hover:tw-opacity-70"
      >
        <Icon icon="ri-close-line" className="tw-text-2xl tw-text-blue-500" />
      </button>
      {account?.paymentsUpdateUrl && (
        <iframe
          data-success-callback="onPaddleSuccess"
          src={account.paymentsUpdateUrl}
          className="tw-h-full tw-w-full"
          title="Update billing details"
        />
      )}
    </div>
  );
};

export default UpdateBillingDetailsDialog;
